<template>
  <div class="container">
    <slot name="title" />
    <div class="container--columns">
      <div
        :class="{
          'container--columns-template-width-30': ratio === '30/70',
          'container--columns-template-width-70': ratio === '70/30',
          'container--columns-template-width-50': ratio === '50/50',
        }"
      >
        <slot name="left" />
      </div>

      <div
        :class="{
          'container--columns-template-width-70': ratio === '30/70',
          'container--columns-template-width-30': ratio === '70/30',
          'container--columns-template-width-50': ratio === '50/50',
        }"
      >
        <slot name="right" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ZgDividedContent',
    props: {
      ratio: {
        type: String,
        required: false,
        default: '50/50'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    padding: rhythm(small) 0;

    &--columns {
      @include mq(medium) {
        display: flex;
        gap: rhythm();

        &-template-width-30 {
          width: 30%;
        }

        &-template-width-70 {
          width: 70%;
        }

        &-template-width-50 {
          width: 50%;
        }
      }
    }
  }
</style>
